<template>
  <div>
    <Form
      page-title="Edit Branch"
      buttonName="Update"
      :businessId="businessId"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateBranch } from "@/API/BranchesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const updateData = {
        locales: formData.locales,
        type: formData.type
      };

      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(
        this,
        updateBranch({
          businessId: formData.business_id,
          id: formData.id,
          data: updateData
        }),
        callback
      );
    }
  }
};
</script>
<style></style>
